import { Pressable, StyleSheet, Text, View } from "react-native";
import React from "react";

const Button = ({ onPress, title, style }) => {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [
        styles.container,
        style,
        pressed && {
          backgroundColor: "#FF8400",
        },
      ]}
    >
      <View>
        <Text style={styles.buttonText}>{title}</Text>
      </View>
    </Pressable>
  );
};

export default Button;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F9DDCE",
    padding: 15,
    borderRadius: 40,
  },
  buttonText: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#F76205",
  },
});
